import {
	reOrgStatusTypeConstants
}from './constants'
import actions from '../../../actions'

const initialState =
{
	isSending  : false,
	paged      : null,
	list       : null,
	changed    : null,
	pagedAudit : null,
	countAudit : null
}

export default function (state = initialState, action){
	switch (action.type){
		case reOrgStatusTypeConstants.GetPaged.REQUEST:
		case reOrgStatusTypeConstants.GetPagedAudit.REQUEST:
		case reOrgStatusTypeConstants.GetPagedAll.REQUEST:
		case reOrgStatusTypeConstants.GetList.REQUEST:
		case reOrgStatusTypeConstants.Create.REQUEST:
		case reOrgStatusTypeConstants.Delete.REQUEST:
		case reOrgStatusTypeConstants.Restore.REQUEST:
		case reOrgStatusTypeConstants.Update.REQUEST:
			return {
				...state,
				isSending : true,
				changed   : null
			}
		case reOrgStatusTypeConstants.GetPaged.FAILURE:
		case reOrgStatusTypeConstants.GetPagedAudit.FAILURE:
		case reOrgStatusTypeConstants.GetPagedAll.FAILURE:
		case reOrgStatusTypeConstants.GetList.FAILURE:
		case reOrgStatusTypeConstants.Create.FAILURE:
		case reOrgStatusTypeConstants.Delete.FAILURE:
		case reOrgStatusTypeConstants.Restore.FAILURE:
		case reOrgStatusTypeConstants.Update.FAILURE:
			return {
				...state,
				isSending : false,
				error     : action.payload,
				changed   : null
			}
		case reOrgStatusTypeConstants.GetPaged.SUCCESS:
		case reOrgStatusTypeConstants.GetPagedAll.SUCCESS:
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}
		case reOrgStatusTypeConstants.GetPagedAudit.SUCCESS:
			return {
				...state,
				isSending  : false,
				pagedAudit : action.payload.result.items,
				countAudit : action.payload.result.count
			}
		case reOrgStatusTypeConstants.GetList.SUCCESS:
			return {
				...state,
				isSending : false,
				list      : action.payload.result
			}
		case reOrgStatusTypeConstants.Create.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.create : null
			}
		case reOrgStatusTypeConstants.Delete.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.delete : null
			}
		case reOrgStatusTypeConstants.Update.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.update : null
			}
		case reOrgStatusTypeConstants.Restore.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.restore : null
			}
		case reOrgStatusTypeConstants.CLEAR:
			return {
				...state,
				changed    : null,
				isSending  : false,
				paged      : null,
				list       : null,
				pagedAudit : null,
				countAudit : null
			}
		default:
			return state
	}
}